import React from "react"
import { Button, Input, Spin, Typography } from "antd"
import { useManagerResetPasswdMutation } from "../../generated-types"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { handleGqlError } from "../../utils/utils"
import SelectLanguage from "../../components/SelectLanguage"
import { useTranslation } from "react-i18next"

export default () => {
  const [email, setEmail] = React.useState("")
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [resetPasswdMutation, { loading }] = useManagerResetPasswdMutation({
    onError: (e) => handleGqlError(e, (msg) => toast(msg, { type: "error" })),
  })

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#00739D" }}>
      <div>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            resetPasswdMutation({ variables: { email } }).then((r) => {
              toast(t("login.send-password-mail.message"), { type: "success" })
              navigate("/")
            })
          }}
        >
          <div style={{ background: "white", borderRadius: "12px", padding: "24px", width: "400px", display: "flex", flexDirection: "column", gap: "12px" }}>
            <Typography.Title level={2} style={{ textAlign: "center", margin: "8px 0" }}>
              {t("login.find-password.word")}
            </Typography.Title>
            <Input
              placeholder={t("session.key.Email.word")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
            <div style={{ position: "relative" }}>
              <Button type="primary" htmlType="submit" block disabled={loading}>
                {t("button.send.word")}
              </Button>
              {loading && (
                <Spin style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
              )}
            </div>
            <Button block disabled={loading} onClick={() => navigate("/")}>
              {t("login.to-login.word")}
            </Button>
          </div>
        </form>
        <div style={{ marginTop: "15px" }}>
          <SelectLanguage style={{ color: "#FFFFFF" }} />
        </div>
      </div>
    </div>
  )
}
